import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { getOSHData } from '../../../api';

class InternationalOrganisationsReport extends Component
{
    constructor (props)
    {
        super(props);

        this.state = {
            matrixPageData: [],
            isFetching: true
        }
    }

    getData = () => {
        try {
            getOSHData('INTERNATIONAL_ORGANISATIONS')
                .then((res) => {
                    this.setState({ matrixPageData: res.resultset })
                })
        } catch (error) {
            console.log('Error fetching data', error)
        } finally {
            this.setState({ ...this.state, isFetching: false })
        }
    }

    componentDidMount(){
        this.setState({ ...this.state, isFetching: true });
        this.getData();
    }

    render()
    {
        return (
            <div>
                {
                    this.state.matrixPageData.length <= 0 ? (
                        <span>{this.props.literals.L20706}</span>
                    ) : ""
                }
                {
                    this.state.matrixPageData.map((data, index) => (
                        <div className={`clearfix international-organisations-items item-`+index} key={index}>
                            <div className="matrix--content--elements">
                                <div className="box-rounded">
                                    <p className="institution-name">
                                        {ReactHtmlParser(this.props.literals["L"+data.text1])}
                                    </p>
                                    <div>
                                        {ReactHtmlParser(this.props.literals["L"+data.text2])}
                                    </div>
                                    <div className="text">
                                        {ReactHtmlParser(this.props.literals["L"+data.text3])}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        )
    }
}

export default InternationalOrganisationsReport;